<template>
  <div class="common-share-wxa-dialog">
    <el-dialog title v-model="innerVisible" top="50%" @close="innerVisible = false" >
      <div class="dialog-header">
        <div class="header-title">{{title}}</div>
        <!-- 关闭 -->
        <div class="header-close" @click="innerVisible = false">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="share-wxa-dialog-body">
        <div class="methods-one">
          <div class="methods-title">方法1：{{methodsOneTitle}}</div>
          <div class="methods-body">
            <div class="methods-step">
              <div class="step-title">
                <div class="step-no">1</div>
                <div class="step-title">打开微信，扫描二维码</div>
              </div>
              <div class="qrcode-box">
                <img class="qrcode" :src="codeUrl" alt="">
              </div>
              <div class="qrcode-desc" v-if="stepOneDesc">{{stepOneDesc}}</div>
            </div>
            <div class="methods-step">
               <div class="step-title">
                <div class="step-no">2</div>
                <div class="step-title">{{stepTwoTitle}}</div>
              </div>
              <div class="step-two-img">
                <img class="img" :src="stepTwoImg" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="methods-two">
          <div class="methods-title">方法2：</div>
          <div class="methods-body">
            <div class="url-input">
              <div class="methods-url">{{h5Url}}</div>
              <div class="copy-url" @click="copyUrl">复制链接</div>
            </div>
            <div class="url-tips">{{methodsTwoTips}}</div>
            
          </div>
        
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wxUtils from '@/libs/wx-utils';
import utils from '@/libs/utils';
import sensorsdata from 'sa-sdk-javascript';

export default {
  components: {},
  props: {
    visible: Boolean,
    title: String,
    page: String,
    scene: String,
    methodsOneTitle: String,
    stepOneDesc: String,
    stepTwoTitle: String,
    stepTwoImg: String,
    methodsTwoTips: String,
    pageFrom: String,
  },
  data() {
    return {
      codeUrl: '',
      h5Url: '',
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
  watch: {
    innerVisible(value) {
      if (value) {
        this.init();
      }
    },
  },
  created() {},
  methods: {
    init() {
      wxUtils.getWxaQrcodeAndUrl({
        page: this.page,
        scene: this.scene,
      }).then((data) => {
        this.codeUrl = data.qrcode_url;
        this.h5Url = data.long_url;
      }).catch(() => {
        // this.innerVisible = false;
      });
    },
    copyUrl() {
      sensorsdata.track('ElementClick', {
        page_from: this.pageFrom,
        click_content: '复制链接',
      });
      utils.copyText(this.h5Url);
      this.$message.success('复制成功');
    },
  },
};
</script>

<style lang="less" scoped>
.common-share-wxa-dialog{
  line-height: 1;
  /deep/ .el-dialog{
    width: 800px;
    border-radius: 5px;
    margin: 0;
    transform: translate(-50%, -50%);
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body{
      padding: 0;
    }
  }
  
  .dialog-header{
    padding: 18px 32px;
    height: 66px;
    display: flex;
    align-items: center;
    position: relative;
    .header-title{
      font-size: 24px;
      color: #2f333d;
      font-weight: 600;
    }
    .header-close{
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      font-size: 15px;
      color: #91999F;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        color: #2F333D;
      }
    }
  }
  .share-wxa-dialog-body{
    padding: 6px 32px 32px 32px;
    .methods-one{
      .methods-title{
        color: #2F333D;
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 12px;
      }
      .methods-body{
        background: #F3F6F9;
        border-radius: 2px;
        padding: 32px;
        display: flex;
        align-items: flex-start;
        justify-content: space-around;
        .methods-step{
          display: flex;
          flex-direction: column;
          align-items: center;
          .step-title{
            display: flex;
            align-items: center;
            .step-no{
              width: 24px;
              height: 24px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 20px;
              font-weight: 600;
              background: #599FFF;
            }
            .step-title{
              margin-left: 8px;
              color: #599FFF;
              font-size: 16px;
              font-weight: 600;
            }
          }
          .qrcode-box{
            margin-top: 20px;
            .qrcode{
              width: 200px;
              height: 200px;
              border-radius: 50%;
            }
          }
          .qrcode-desc{
            margin-top: 12px;
            color: #2F333D;
            font-size: 14px;
            line-height: 20px;
            max-width: 200px;
          }
          .step-two-img{
            margin-top: 20px;
            .img{
              width: 200px;
            }
          }
        }
      }
    }
    .methods-two{
      margin-top: 24px;
      display: flex;
      align-items: flex-start;
      .methods-title{
        flex-shrink: 0;
        color: #2F333D;
        font-size: 18px;
        font-weight: 600;
        line-height: 40px;
      }
      .methods-body{
        flex-grow: 1;
        overflow: hidden;
        .url-input{
          border-radius: 2px;
          border: 1px solid #DEE2E6;
          padding: 0 8px 0 18px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #2F333D;
          font-size: 14px;
          .methods-url{
            flex-grow: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 24px;
            line-height: 1.5;
          }
          .copy-url{
            flex-shrink: 0;
            padding: 0 12px;
            height: 28px;
            background: #599FFF;
            border-radius: 2px;
            display: flex;
            align-items: center;
            color: #fff;
            font-size: 14px;
            cursor: pointer;
          }
        }
        .url-tips{
          margin-top: 8px;
          font-size: 12px;
          color: #91999F;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/share/common-share-wxa-dialog.vue